/**
 * @file Global Error Boundary
 * @description
 * Catches unhandled errors in the root layout or nested layouts.
 * Provides a recovery mechanism.
 */

'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/button';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html>
      <body className="flex h-screen flex-col items-center justify-center bg-slate-50 text-center p-4">
        <h2 className="text-2xl font-bold text-slate-900">Something went wrong!</h2>
        <p className="mt-2 text-slate-500 mb-6">
          A critical error occurred. Our team has been notified.
        </p>
        <div className="space-x-4">
            <Button onClick={() => reset()}>
            Try again
            </Button>
            <Button variant="outline" onClick={() => window.location.href = '/'}>
                Go Home
            </Button>
        </div>
      </body>
    </html>
  );
}